/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 Open Assessment Technologies SA;
 */

import { __ } from '@oat-sa-private/ui-core';

/**
 * Generate instructions for using hotspot choice as a part of full aria-label
 *
 * @param {boolean} disabled
 * @param {boolean} selected
 * @returns {string} instructions for using in aria-label
 */
export default function ariaInstructions(disabled, selected) {
    const aria = {
        buttonUnselected: __('unselected toggle button'),
        buttonSelected: __('selected toggle button'),
        buttonDisabled: __('disabled toggle button'),
        instructionUnselected: __('press enter or space to select'),
        instructionSelected: __('press enter or space to deselect'),
        instructionKeys: __('to move to next available option, use the arrow keys')
    };
    let buttonLabel = '';
    let instructionLabel = '';

    if (disabled) {
        buttonLabel = aria.buttonDisabled;
    } else {
        buttonLabel = selected ? aria.buttonSelected : aria.buttonUnselected;
        instructionLabel = selected ? aria.instructionSelected : aria.instructionUnselected;
    }

    return [buttonLabel, instructionLabel, aria.instructionKeys].join(', ');
}
